export class Geo2 {
    static FromGeoJson(coordinates) {
        return new Geo2(coordinates[1], coordinates[0]);
    }
    static Parse(value) {
        const parts = value.replace(/[\[\]]/g, "").split(",");
        const lat = parseFloat(parts[0]);
        const lon = parseFloat(parts[1]);
        return new Geo2(lat, lon);
    }
    static ToString(value) {
        return `[${value.lat},${value.lon}]`;
    }
    static Zero() {
        return new Geo2(0, 0);
    }
    constructor(lat, lon) {
        this._lat = lat;
        this._lon = lon;
    }
    get lat() {
        return this._lat;
    }
    get lon() {
        return this._lon;
    }
    set lat(v) {
        this._lat = v;
    }
    set lon(v) {
        this._lon = v;
    }
    clone() {
        return new Geo2(this._lat, this._lon);
    }
    equals(other) {
        return this._lat === other.lat && this._lon === other.lon;
    }
    toString() {
        return `[${this._lat},${this._lon}]`;
    }
}
Geo2.Default = new Geo2(46.382581, -0.308024);
export class Geo3 extends Geo2 {
    static FromGeoJson(coordinates) {
        if (coordinates.length === 2) {
            return new Geo3(coordinates[1], coordinates[0]);
        }
        return new Geo3(coordinates[1], coordinates[0], coordinates[2]);
    }
    static ToString(value) {
        if (value.alt !== undefined) {
            return `[${value.lat},${value.lon},${value.alt}]`;
        }
        return `[${value.lat},${value.lon}]`;
    }
    static Parse(value) {
        const parts = value.replace(/[\[\]]/g, "").split(",");
        const lat = parseFloat(parts[0]);
        const lon = parseFloat(parts[1]);
        if (parts.length > 2) {
            const alt = parseFloat(parts[2]);
            return new Geo3(lat, lon, alt);
        }
        return new Geo3(lat, lon);
    }
    static Zero() {
        return new Geo3(0, 0, 0);
    }
    constructor(lat, lon, alt) {
        super(lat, lon);
        this._alt = alt;
    }
    get alt() {
        return this._alt;
    }
    set alt(v) {
        this._alt = v;
    }
    get hasAltitude() {
        return this._alt !== undefined;
    }
    clone() {
        return new Geo3(this._lat, this._lon, this._alt);
    }
    equals(other) {
        return this._lat === other.lat && this._lon === other.lon && this._alt === other.alt;
    }
    toString() {
        return this.hasAltitude ? `(${this._lat}, ${this._lon}, ${this._alt})` : `(${this._lat}, ${this._lon})`;
    }
}
//# sourceMappingURL=geography.position.js.map